import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../../../../utils/request';
import Locked from './Locked';

import actions from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { email } = request.getProfile();

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        _.get(actions, status, []).map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
